import {FormField} from "../form-field/form-field";

export class FormFieldSelectImage extends FormField{
    getVal(){
        return this.$value.val();
    }

    setVal(val,noEvent){
        this.$value.val(val);
        this.findMember("item").removeClass("is-selected").filter("[data-value='"+val+"']").addClass("is-selected");
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

    ready(){
        super.ready();
        this.$value = this.findMember("value");
        this.findMember("item").click(
            (ev) => {
                const value = $(ev.currentTarget).data("value");
                if(this.getVal()==value){
                    this.setVal("");
                }else{
                    this.setVal(value);
                }
            }
        );
    }
}

